import { render } from "./HeroiconsSolidCursorClick.vue?vue&type=template&id=3aada87f"
const script = {}

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCursorClick.vue"]])

export default __exports__